import { render } from "./addCampus.vue?vue&type=template&id=7b08dcce&scoped=true"
import script from "./addCampus.vue?vue&type=script&lang=js"
export * from "./addCampus.vue?vue&type=script&lang=js"

import "./addCampus.vue?vue&type=style&index=0&id=7b08dcce&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b08dcce"]])

export default __exports__